import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  Validators,
  UntypedFormControl,
} from "@angular/forms";
import { Actions, ofActionSuccessful, Store } from "@ngxs/store";
import { ResetPasswordEmail } from "src/app/states/actions/user.actions";
import { Location } from "@angular/common";

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: ["./password-reset.component.scss"],
})
export class PasswordResetComponent implements OnInit {
  email: UntypedFormControl;

  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    private actions: Actions,
    private _location: Location
  ) {}

  ngOnInit() {
    this.email = this.fb.control(null, [
      Validators.required,
      Validators.pattern(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/),
      ,
    ]);
  }

  send = () => {
    this.store.dispatch(new ResetPasswordEmail(this.email.value));
    this.actions.pipe(ofActionSuccessful(ResetPasswordEmail)).subscribe(() => {
      this.email.reset();
    });
  };

  goBack = () => {
    this._location.back();
  };
}
